module.exports = __webpack_public_path__ + "static/media/logo-tka.69ddeff1.png";